// in 32.x.x replace with import { hasAnyPermissions } from '../../../utils/helpers';
import {
    hasAnyPermissions,
    removeCurrentPassowrdFromFormProps,
    removeCurrentPasswordFormFromFormSections,
} from '../utils';

export default {
    name: 'userFormPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'userForm';
        const route = app.routes.getItem(routeName);
        if (route) {
            const routeProps = route.props;

            const customRegularUserFormProps = (_sections) => {
                const sections = removeCurrentPasswordFormFromFormSections(_sections);

                return {
                    ...sections,
                    other: (sections?.other || []).filter(({ name }) => name !== 'warehouse_with_dropship'),
                };
            };

            route.props = (state) => ({
                ...routeProps(state),
                customAdminUserFormFields: removeCurrentPasswordFormFromFormSections,
                customAdminUserFormProps: removeCurrentPassowrdFromFormProps,
                customRegularUserFormFields: customRegularUserFormProps,
                customRegularUserFormProps: removeCurrentPassowrdFromFormProps,
                customVendorUserFormFields: removeCurrentPasswordFormFromFormSections,
                customVendorUserFormProps: removeCurrentPassowrdFromFormProps,

                //to remove in 32.x.x
                permissions: {
                    canAdd: hasAnyPermissions('users.create'),
                    canEdit: hasAnyPermissions('users.update'),
                    canEditCustomValues: hasAnyPermissions('users - custom attributes.value edit'),
                },
            });

            app.routes.changeItem(routeName, route);
        }
    },
};
